export default __webpack_public_path__ + "static/media/responsive.d5fd70c1.svg";